import { render } from "./NonTCFVendorItem.vue?vue&type=template&id=18d43589&scoped=true&ts=true"
import script from "./NonTCFVendorItem.vue?vue&type=script&lang=ts"
export * from "./NonTCFVendorItem.vue?vue&type=script&lang=ts"

import "./NonTCFVendorItem.vue?vue&type=style&index=0&id=18d43589&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d43589"]])

export default __exports__